/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface ISessionsConnectMessage extends IMessage {
	id: string;
	sessionType: number | string;
}

export default class SessionsConnectMessage extends Message {
	public static readonly TYPE: string = '31';

	public static readonly READABLE_TYPE_NAME: string = 'getConnectedSockets';

	public static readonly DESCRIPTOR_NAME: string = 'SessionsConnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			sessionType: {
				type: 'uint32',
				id: 2
			}
		}
	};

	public constructor( public readonly id: string, public readonly sessionType: string | number ) {
		super();
	}

	public toJSON(): ISessionsConnectMessage {
		return {
			id: this.id,
			sessionType: this.sessionType
		};
	}

	public static fromJSON( data: ISessionsConnectMessage ): SessionsConnectMessage {
		return new SessionsConnectMessage( data.id, data.sessionType );
	}
}
